export function stringify(obj, options = {}) {
    try {
        const qs = new URLSearchParams(obj).toString();
        return ((options === null || options === void 0 ? void 0 : options.addQueryPrefix) && qs.length ? '?' : '') + qs;
    }
    catch (err) {
        console.error("Can't stringify", obj, err);
        return '';
    }
}
export function toObject(qstring) {
    const obj = {};
    try {
        const params = new URLSearchParams(qstring);
        for (const key of params.keys()) {
            if (params.getAll(key).length > 1) {
                obj[key] = params.getAll(key);
            }
            else {
                obj[key] = params.get(key);
            }
        }
    }
    catch (err) {
        console.error('Cant convert querystring to object', qstring, err);
    }
    return obj;
}
